import React, { useState } from "react";
import ExpandableSection from "../../../../components/ExpandableSection";
import AssetEditPopup from "./AssetEditPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";

export default function ProjectAssets(props) {

  var {
    assets
  } = props;

  var [showAssetPopup, setShowAssetPopup] = useState(false);
  var [selectedAsset, setSelectedAsset] = useState(null);

  function openAssetEdit(asset) {
    setSelectedAsset(asset);
    setShowAssetPopup(true);
  }

  const styles = {

    /* -------------------------------------------------
       CONTAINER & HEADER
    ------------------------------------------------- */

    container: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
      overflow: "hidden",
      width: "100%"
    },

    header: {
      padding: "16px 20px",
      borderBottom: "1px solid #e6e6e6",
      background: "linear-gradient(180deg, #FFFFFF 0%, #E7E9EC 100%)"
    },

    title: {
      fontSize: "18px",
      fontWeight: 600
    },

    subTitle: {
      fontSize: "12px",
      color: "#666"
    },

    /* -------------------------------------------------
       GRID HEADER
    ------------------------------------------------- */

    gridHeader: {
      display: "grid",
      gridTemplateColumns: "1.2fr 1.2fr 2fr 1.5fr 1.5fr 1fr 0.6fr",
      padding: "10px 12px",
      fontSize: "12px",
      fontWeight: 600,
      color: "#555",
      background: "#f4f6f8",
      borderBottom: "1px solid #dfe3e8"
    },

    /* -------------------------------------------------
       ROWS
    ------------------------------------------------- */

    list: {
      flex: 1,
      overflowY: "auto"
    },

    assetRow: {
      display: "grid",
      gridTemplateColumns: "1.2fr 1.2fr 2fr 1.5fr 1.5fr 1fr 0.6fr",
      paddingLeft: "12px",
      alignItems: "center",
      borderBottom: "1px solid #e6e9ee",
      fontSize: "12px",
	  height:"40px"
    },

    assetRowAlt: {
      background: "white"
    },

    /* -------------------------------------------------
       CELLS
    ------------------------------------------------- */

    nameCell: {
      fontWeight: 600
    },

    editCell: {
      display: "flex",
      justifyContent: "center"
    },

    editIcon: {
      color: "#1e58b6",
      cursor: "pointer",
      opacity: 0.85
    },

    /* -------------------------------------------------
       STATUS PILLS
    ------------------------------------------------- */

	statusPill: {
		  display:'flex',
	      padding: "4px 10px",
	      borderRadius: "7px",
	      fontSize: "12px",
		  alignItems:'center',
		  justifyContent:'space-around',
		  minWidth:'70px'
	    },

    statusAssigned: {
      background: "#006600",
      color: "#fff"
    },

    statusPending: {
      background: "#996600",
      color: "#fff"
    },

    statusUnallocated: {
      background: "#990000",
      color: "#fff"
    }
  };

  return (
    <ExpandableSection
      title="Desks / Furniture / Assets"
      buttonLabel="New Item"
      onButtonClick={function () {
        props.setShowMovePopup(true);
      }}
    >
      <div style={styles.container}>

        {/* HEADER */}
        <div style={styles.header}>
          <div style={styles.title}>Assets</div>
          <div style={styles.subTitle}>
            {assets.length} records
          </div>
        </div>

        {/* TABLE HEADER */}
        <div style={styles.gridHeader}>
          <div>Type</div>
          <div>Class</div>
          <div>Name</div>
          <div>Asset No</div>
          <div>Manufacturer</div>
          <div>Status</div>
          <div></div>
        </div>

        {/* ROWS */}
        <div style={styles.list}>
          {assets.map(function (a, idx) {
            return (
              <div
                key={a.id}
                style={{
                  ...styles.assetRow,
                  ...(idx % 2 === 1 ? styles.assetRowAlt : {})
                }}
              >
                <div>{a.type}</div>
                <div>{a.assetClass}</div>
                <div style={styles.nameCell}>{a.name}</div>
                <div>{a.assetNumber}</div>
                <div>{a.manufacturer}</div>

                <div>
                  <span
                    style={{
                      ...styles.statusPill,
                      ...(a.status === "Assigned"
                        ? styles.statusAssigned
                        : a.status === "Pending"
                        ? styles.statusPending
                        : styles.statusUnallocated)
                    }}
                  >
                    {a.status}
                  </span>
                </div>

                <div style={styles.editCell}>
                  <FontAwesomeIcon
                    icon={faPen}
                    style={styles.editIcon}
                    onClick={function () {
                      openAssetEdit(a);
                    }}
                  />
                </div>
              </div>
            );
          })}
        </div>

      </div>

      <AssetEditPopup
        open={showAssetPopup}
        asset={selectedAsset}
        onClose={function () {
          setShowAssetPopup(false);
        }}
      />
    </ExpandableSection>
  );
}
